module.exports = __webpack_public_path__ + "img/item7.cdcf2fec.png";